import { put, select } from 'redux-saga/effects';
import Immutable from 'immutable';
import { resultsConfigSelector, quoteFormSelector } from 'ctm-selectors';

/**
 * Saga to cancel each staged filter and return the staged filters to their original value / the value since the last
 * time results were retrieved
 * @param {Object} action - The 'CANCEL_STAGED_FILTERS' action
 */
export const cancelStagedFilters = function* (action) {
    const resultsConfig = yield select(resultsConfigSelector);
    const currentActions = resultsConfig.getIn(['filters', 'currentFilterActions']);
    for (const filterAction of currentActions) {
        const origValue = filterAction.originalValue || resultsConfig.getIn(filterAction.resultsStateKey.split('.'));
        yield put({ type: 'SET_RESULTS_CONFIG_VALUE', key: filterAction.resultsStagedStateKey, value: origValue });
    }
    const resultsConfigAction = {
        type: 'SET_RESULTS_CONFIG_VALUES',
        actions: [
            {
                key: 'filters.showFiltersUpdateButton',
                value: false
            },
            {
                key: 'filters.fetchNewResults',
                value: false
            },
            {
                key: 'filters.currentFilterActions',
                value: Immutable.List()
            }
        ]
    };
    yield put(resultsConfigAction);
};

/**
 * Saga to cancel each staged filter and return the staged filters to their original value / the value since the last
 * time results were retrieved
 * @param {Object} action - The 'CANCEL_STAGED_FILTERS' action
 */
export const applyStagedFilters = function* (action) {
    const resultsConfig = yield select(resultsConfigSelector);
    const quoteForm = yield select(quoteFormSelector);
    const currentActions = resultsConfig.getIn(['filters', 'currentFilterActions']);

    const changingLogs = [];
    for (const filterAction of currentActions) {
        const { value, resultsStagedStateKey, formStateKey } = filterAction;
        const origValue = value || resultsConfig.getIn(resultsStagedStateKey.split('.'));

        const formValue = quoteForm.getIn(formStateKey.split('.'));
        const keys = resultsStagedStateKey.split('.');
        const filterType = keys[keys.length - 1];
        const prev = formValue;
        const current = origValue;
        changingLogs.push(
            {
                filterType,
                prev,
                current
            }
        );

        yield put({ type: 'SET_VALUE', stateKey: 'vertical.quote', identifier: formStateKey, value: origValue });
    }

    yield put({
        type: 'SET_PAGE_VALUE',
        identifier: 'applyStagedFilters',
        value: changingLogs
    });

    yield put({ type: 'SET_RESULTS_CONFIG_VALUE', key: 'filters.currentFilterActions', value: Immutable.List() });
};
